import type { ErrorComponentProps } from "owa-error-boundary/lib/ErrorBoundary";
import type * as DesktopErrorComponent from "./DesktopErrorComponent";
import { type LazyComponent, LazyModule, createLazyComponent } from "owa-bundling";

// Only load the code to display the error component in the rare cases where we actually encounter an error.
const desktopErrorComponentModule: LazyModule<typeof DesktopErrorComponent> = new LazyModule<typeof DesktopErrorComponent>(() => import(/*webpackChunkName: "DesktopErrorComponent" */ "./DesktopErrorComponent"), {
    name: "DesktopErrorComponent",
});

export const DesktopErrorComponentAsync: LazyComponent<ErrorComponentProps, unknown, void> = createLazyComponent(desktopErrorComponentModule, m => m.default);
